import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import { GridColumn, GridColumnType } from "@/components/child/grid/gridColumn";
import { Component, Watch } from "@/decorators";
import TipoBuscaMovimentacao from "@/models/enum/estoque/tipoBuscaMovimentacao";
import TiposMovimentacaoEstoque from "@/models/enum/tiposMovimentacaoEstoque";
import MovimentacaoEstoqueModel, { MovimentacaoEstoqueListParameters } from "@/models/movimentacaoEstoqueModel";
import PaginationModel from "@/models/paginationModel";
import estoqueService from "@/services/estoqueService";
import MovimentacaoEstoqueService from "@/services/movimentacaoEstoqueService";
import { addDays, convertToDateInputString } from "@/utils/common/date";

import ListComponentBase from "../listComponentBase";

@Component({
    components: {
        comboComponent,
        dateTimePickerComponent,
    },
})
export default class MovimentacaoEstoqueListComponent extends ListComponentBase<MovimentacaoEstoqueModel> {
    get gridColumns(): Array<GridColumn> {
        return [
            new GridColumn("dataMovimentacao", "Data", GridColumnType.DateTime),
            new GridColumn(
                "tipoMovimentacaoDescricao",
                "Tipo",
                GridColumnType.String,
                false,
                false,
                "",
                "",
                false,
                false,
            ),
            new GridColumn("descricaoEstoque", "Estoque", GridColumnType.String),
            new GridColumn("produtoDescricao", "Produto", GridColumnType.String),
            new GridColumn("quantidade", "Quantidade", GridColumnType.DecimalPonto),
            new GridColumn("unidadeMedida", "Un.Medida", GridColumnType.String),
            new GridColumn("loteDescricao", "Lote", GridColumnType.String),
        ];
    }

    private tiposMovimentosOptions: Array<Object> = [
        { text: "Entrada", value: TiposMovimentacaoEstoque.Entrada },
        { text: "Sa\u00edda", value: TiposMovimentacaoEstoque.Saida },
        { text: "Transfer\u00eancia", value: TiposMovimentacaoEstoque.Transferencia },
    ];
    private estoquesOptions: Array<Object> = [];
    private tipoBuscaMovimentacaoOptions: Array<Object> = [
        { text: "Produto Lote", value: TipoBuscaMovimentacao.Lote },
        { text: "Produto", value: TipoBuscaMovimentacao.Produto },
    ];

    private dataFinal: Date | null = new Date();
    private dataInicial: Date | null = addDays(-90, this.dataFinal!);
    private tipoMovimentoFiltro: number | null = null;
    private estoqueFiltro: number | null = null;
    private tipoBuscaMovimentacao: TipoBuscaMovimentacao = TipoBuscaMovimentacao.Lote;

    private tituloPesquisa = `${this.$t("__.Crud.movimentacaoestoque.list_vue_html.movimentaEstq")} (últimos 3 meses)`;
    private jaPesquisou = false;

    private beforeMount() {
        this.setProps(new MovimentacaoEstoqueService(), "movimentacaoestoque", "dataMovimentacao");

        this.gridSortOrder = "desc";

        this.loadEstoques();
    }

    private async loadEstoques() {
        try {
            this.estoquesOptions = await estoqueService.comboCached(this.usuarioLogado.franquiaId!);
        } catch {}
    }

    public async loadMethod() {
        const customParameters: MovimentacaoEstoqueListParameters = {
            filterKeyId: "",
            dataMovimentacaoIniStr: convertToDateInputString(this.dataInicial),
            dataMovimentacaoFinStr: convertToDateInputString(this.dataFinal, true),
            tipoMovimentacaoId: this.tipoMovimentoFiltro,
            estoqueId: this.estoqueFiltro,
            tipoBuscaMovimentacao: this.tipoBuscaMovimentacao,
        };

        this.jaPesquisou = true;

        return await this.service
            .list(
                this.gridFilterKey,
                this.gridSortKey,
                this.gridSortOrder,
                this.pags ? 1 : this.pageIndex,
                this.pags ? 999999 : this.pageSize,
                customParameters,
            )
            .withLoading()
            .resolveWithJSON<PaginationModel<MovimentacaoEstoqueModel>>();
    }

    @Watch("tipoBuscaMovimentacao")
    private async watchTipoBuscaMovimentacao() {
        this.loadMethod();
    }

    private calculaDiferenca = (data1, data2): number => {
        const diferencaEmMilisegundos = Number(data2) - Number(data1);
        const diferencaEmDias = diferencaEmMilisegundos / (1000 * 60 * 60 * 24);
        return Math.ceil(diferencaEmDias);
    };

    @Watch("dataInicial")
    private async watchDataInicial() {
        if (!this.dataInicial || !this.dataFinal) {
            return (this.tituloPesquisa = `${this.$t("__.Crud.movimentacaoestoque.list_vue_html.movimentaEstq")}`);
        }

        if (this.calculaDiferenca(this.dataInicial, this.dataFinal) > 365) {
            await this.$showWarning(
                this.$t("__.ts.aviso"),
                this.$t("__.Components.parent.crud.movimentacaoestoque.list_vue_html.avisoRangeData"),
            );

            this.dataInicial = null;
        }

        if (this.jaPesquisou) {
            this.tituloPesquisa = `${this.$t("__.Crud.movimentacaoestoque.list_vue_html.movimentaEstq")}`;
        }
    }

    @Watch("dataFinal")
    private async watchDataFinal() {
        if (!this.dataInicial) return;
        if (!this.dataFinal) return;

        if (this.calculaDiferenca(this.dataInicial, this.dataFinal) > 365) {
            await this.$showWarning(
                this.$t("__.ts.aviso"),
                this.$t("__.Components.parent.crud.movimentacaoestoque.list_vue_html.avisoRangeData"),
            );

            this.dataFinal = null;
        }

        if (this.jaPesquisou) {
            this.tituloPesquisa = `${this.$t("__.Crud.movimentacaoestoque.list_vue_html.movimentaEstq")}`;
        }
    }
}
